/*
  DWF — Door & Window Finder
  window.DWF is defined immediately (not inside an IIFE) so that
  onclick="DWF.*" attributes in the HTML always resolve correctly.

  Flow:
    1. _DWF_CATALOG is already populated by the Liquid script block above.
    2. User picks type + category chip + dimensions → "Find match"
    3. _dwfFetchProducts() slices from _DWF_CATALOG (instant, no fetch)
    4. _dwfFilter() matches by custom.bredde / custom.hojde metafields
    5. _dwfRender() displays cards
*/

/* ── State ─────────────────────────────────────────────── */
var _DWF_STATE  = { type: 'door', handle: '__all__', w: 93, h: 202, d: 60, isDiameter: false };
var _DWF_GAP    = { min: 2, max: 5 }; /* overwritten on DOMContentLoaded */

/* ── Helpers ────────────────────────────────────────────── */
function _dwfEl(id) { return document.getElementById(id); }

function _dwfUpdatePreview(w, h) {
  var minPx = 50, maxPx = 190;
  var pxW = Math.round(minPx + ((w - 40) / 260) * (maxPx - minPx));
  var pxH = Math.round(minPx + ((h - 40) / 260) * (maxPx - minPx));
  var box = _dwfEl('dwf-box');
  if (!box) return;
  box.style.width  = pxW + 'px';
  box.style.height = pxH + 'px';
  _dwfEl('dwf-lbl-w').textContent = w + ' cm';
  _dwfEl('dwf-lbl-h').textContent = h + ' cm';
  _dwfEl('dwf-leg-w').textContent = w + ' cm';
  _dwfEl('dwf-leg-h').textContent = h + ' cm';
  _dwfEl('dwf-leg-fw').textContent = (w - _DWF_GAP.max) + ' – ' + (w - _DWF_GAP.min) + ' cm';
  _dwfEl('dwf-leg-fh').textContent = (h - _DWF_GAP.max) + ' – ' + (h - _DWF_GAP.min) + ' cm';
}

/* Update the round preview + diameter legend (round window categories only) */
function _dwfUpdatePreviewDiameter(d) {
  var circle = _dwfEl('dwf-circle');
  if (!circle) return;
  var input  = _dwfEl('dwf-d');
  var min    = (input && parseInt(input.min)) || 45;
  var max    = (input && parseInt(input.max)) || 110;
  var minPx = 50, maxPx = 190;
  var px = Math.round(minPx + ((d - min) / (max - min)) * (maxPx - minPx));
  circle.style.width  = px + 'px';
  circle.style.height = px + 'px';
  var lblD = _dwfEl('dwf-lbl-d');   if (lblD) lblD.textContent = d + ' cm';
  var legD = _dwfEl('dwf-leg-d');   if (legD) legD.textContent = d + ' cm';
  var legFD = _dwfEl('dwf-leg-fd');
  if (legFD) legFD.textContent = (d - _DWF_GAP.max) + ' – ' + (d - _DWF_GAP.min) + ' cm';
}

/* Toggle Step 3 + preview between width/height mode and diameter mode */
function _dwfToggleDimUI(isDiameter) {
  var whFields = _dwfEl('dwf-wh-fields');
  var dField   = _dwfEl('dwf-d-field');
  var rectPrev = _dwfEl('dwf-box');
  var circPrev = _dwfEl('dwf-circle');
  var legWH    = _dwfEl('dwf-legend-wh');
  var legD     = _dwfEl('dwf-legend-d');

  if (whFields) whFields.style.display = isDiameter ? 'none' : '';
  if (dField)   dField.style.display   = isDiameter ? '' : 'none';
  if (rectPrev) rectPrev.style.display = isDiameter ? 'none' : '';
  if (circPrev) circPrev.style.display = isDiameter ? 'flex' : 'none';
  if (legWH)    legWH.style.display    = isDiameter ? 'none' : '';
  if (legD)     legD.style.display     = isDiameter ? '' : 'none';

  if (isDiameter) {
    _dwfUpdatePreviewDiameter(_DWF_STATE.d);
  } else {
    _dwfUpdatePreview(_DWF_STATE.w, _DWF_STATE.h);
  }
}

/*
  ── Get products from the pre-rendered catalog (no HTTP fetch) ──
  - Specific handle → return that collection's products from _DWF_CATALOG.
  - __all__         → merge products from every handle in the active
                      cat-grid's data-all-handles, deduplicated by id.
*/
async function _dwfFetchProducts(handle, type) {
  if (handle !== '__all__') {
    return _DWF_CATALOG[handle] || [];
  }

  var gridId = type === 'door' ? 'dwf-door-cats' : 'dwf-window-cats';
  var grid   = _dwfEl(gridId);
  var raw    = (grid ? grid.dataset.allHandles || '' : '').trim();
  if (!raw) return [];

  var handles = raw.split(',').map(function(h){ return h.trim(); }).filter(Boolean);
  var seen = new Set(), merged = [];
  handles.forEach(function(h) {
    (_DWF_CATALOG[h] || []).forEach(function(p) {
      if (!seen.has(p.id)) { seen.add(p.id); merged.push(p); }
    });
  });
  return merged;
}

/* Filter catalog products by karmW/karmH against opening dimension range */
function _dwfFilter(products, wMin, wMax, hMin, hMax) {
  return products.filter(function(p) {
    var kw = parseFloat(p.karmW);
    var kh = parseFloat(p.karmH);
    if (isNaN(kw) || isNaN(kh)) return false;
    return kw >= wMin && kw <= wMax && kh >= hMin && kh <= hMax;
  });
}

/* Filter catalog products by karmD (custom.storrelse_diameter) against opening diameter range */
function _dwfFilterDiameter(products, dMin, dMax) {
  return products.filter(function(p) {
    var kd = parseFloat(p.karmD);
    if (isNaN(kd)) return false;
    return kd >= dMin && kd <= dMax;
  });
}

/* Render product cards — horizontal layout (thumbnail left, info right) */
function _dwfRender(products) {
  var grid  = _dwfEl('dwf-grid');
  var empty = _dwfEl('dwf-empty');
  if (!products.length) {
    grid.innerHTML = '';
    empty.style.display = 'block';
    return;
  }
  empty.style.display = 'none';

  var doorSVG = '<svg viewBox="0 0 36 50" fill="none">'
    + '<rect x="1" y="1" width="34" height="48" rx="1.5" fill="#e8f5e9" stroke="#2E7D32" stroke-width="2"/>'
    + '<rect x="4" y="4" width="28" height="42" rx="1" fill="#fff" stroke="#a5d6a7" stroke-width="1"/>'
    + '<circle cx="28" cy="26" r="2.5" fill="#2E7D32"/>'
    + '</svg>';

  grid.innerHTML = products.map(function(p) {
    var variant = (p.variants || [])[0] || {};
    var img     = (p.images   || [])[0];
    var price   = variant.price
      ? parseFloat(variant.price).toLocaleString('da-DK', { minimumFractionDigits: 2 }) + ' kr'
      : '';
    var dW = parseFloat(p.karmW) || null;
    var dH = parseFloat(p.karmH) || null;
    var dD = parseFloat(p.karmD) || null;

    var imgContent = img
      ? '<img src="' + img.src + '" alt="' + (img.alt || p.title).replace(/"/g, '&quot;') + '" loading="lazy" style="width:100%;height:100%;object-fit:cover;border-radius:6px;">'
      : doorSVG;

    var frameMeta = (dW !== null && dH !== null) ? 'Frame: ' + dW + ' x ' + dH + ' cm' : '';

   return '<div class="dwf-card">'
  + '<div class="dwf-card-img">' + imgContent + '</div>'
  + '<div class="dwf-card-body">'
  + '<div class="dwf-card-content">'
  + '<div class="dwf-card-top">'
  + '<div class="dwf-card-badge">'
  + '✓ Passer</div>'
  + (p.id ? '<div class="dwf-card-sku">' + p.id + '</div>' : '')
  + '</div>' 
  + '<div class="dwf-card-name">' + p.title + '</div>'
  + (price ? '<div class="dwf-card-price">' + price + '</div>' : '')
  + (dD !== null ? '<div class="dwf-card-dim">Ø ' + dD + ' cm</div>' : '')
  + '</div>'
  + '<div class="dwf-card-footer">'
  +  '<a class="dwf-card-btn" href="/products/' + p.handle + '">'
+ 'Se mere '
+ '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">'
+ '<g clip-path="url(#clip0_1616_359)">'
+ '<path d="M11.6798 12.938L11.6606 7.56279L4.4575 14.7903L3.39684 13.7296L10.5999 6.50213L5.22469 6.48291L5.22471 4.98306L13.1604 5.00231L13.1797 12.938L11.6798 12.938Z" fill="#121413"/>'
+ '</g>'
+ '<defs>'
+ '<clipPath id="clip0_1616_359">'
+ '<rect width="18" height="18" fill="white"/>'
+ '</clipPath>'
+ '</defs>'
+ '</svg>'
+ '</a>'
  + '</div>'
  + '</div></div>';
  }).join('');
  
}
/* ── Public API — defined at top level so onclick always finds it ── */
window.DWF = {

  selectType: function(type, el) {
    _DWF_STATE.type = type;
    document.querySelectorAll('.dwf-type-card').forEach(function(c){ c.classList.remove('active'); });
    el.classList.add('active');
    _dwfEl('dwf-door-cats').style.display   = type === 'door'   ? 'flex' : 'none';
    _dwfEl('dwf-window-cats').style.display = type === 'window' ? 'flex' : 'none';
    var catGrid = _dwfEl('dwf-' + type + '-cats');
    catGrid.querySelectorAll('.dwf-chip').forEach(function(c){ c.classList.remove('active'); });
    var first = catGrid.querySelector('.dwf-chip');
    if (first) {
      first.classList.add('active');
      _DWF_STATE.handle = first.dataset.handle;
      _DWF_STATE.isDiameter = first.dataset.diameter === 'true';
      _dwfToggleDimUI(_DWF_STATE.isDiameter);
    }
    _dwfEl('dwf-results').style.display = 'none';
  },

  selectCat: function(el) {
    el.closest('.dwf-cat-grid').querySelectorAll('.dwf-chip').forEach(function(c){ c.classList.remove('active'); });
    el.classList.add('active');
    _DWF_STATE.handle = el.dataset.handle;
    _DWF_STATE.isDiameter = el.dataset.diameter === 'true';
    _dwfToggleDimUI(_DWF_STATE.isDiameter);
  },

  syncDim: function(src) {
    var iW = _dwfEl('dwf-w'),  iH = _dwfEl('dwf-h');
    var sW = _dwfEl('dwf-sw'), sH = _dwfEl('dwf-sh');
    if      (src === 'sw') iW.value = sW.value;
    else if (src === 'sh') iH.value = sH.value;
    else if (src === 'w')  sW.value = iW.value;
    else if (src === 'h')  sH.value = iH.value;
    _DWF_STATE.w = parseInt(iW.value) || 93;
    _DWF_STATE.h = parseInt(iH.value) || 202;
    _dwfUpdatePreview(_DWF_STATE.w, _DWF_STATE.h);
  },

  syncDiameter: function(src) {
    var iD = _dwfEl('dwf-d'), sD = _dwfEl('dwf-sd');
    if      (src === 'sd') iD.value = sD.value;
    else if (src === 'd')  sD.value = iD.value;
    _DWF_STATE.d = parseInt(iD.value) || 60;
    _dwfUpdatePreviewDiameter(_DWF_STATE.d);
  },

  findMatch: async function() {
    _dwfEl('dwf-loading').style.display = 'flex';
    _dwfEl('dwf-results').style.display = 'none';

    try {
      var all = await _dwfFetchProducts(_DWF_STATE.handle, _DWF_STATE.type);
      var matched, metaSuffix;

      if (_DWF_STATE.isDiameter) {
        var d = _DWF_STATE.d;
        var dMin = d - _DWF_GAP.max, dMax = d - _DWF_GAP.min;
        matched = _dwfFilterDiameter(all, dMin, dMax);
        metaSuffix = ' matcher din diameter: ' + d + ' cm';
      } else {
        var w = _DWF_STATE.w, h = _DWF_STATE.h;
        var wMin = w - _DWF_GAP.max, wMax = w - _DWF_GAP.min;
        var hMin = h - _DWF_GAP.max, hMax = h - _DWF_GAP.min;
        matched = _dwfFilter(all, wMin, wMax, hMin, hMax);
        metaSuffix = ' matcher dine mål: ' + w + ' × ' + h + ' cm';
      }

      var catLabel = document.querySelector('.dwf-chip.active')
        ? (document.querySelector('.dwf-chip.active').dataset.label || '') : '';

      _dwfEl('dwf-res-meta').innerHTML =
        '<span>' + matched.length + ' produkt' + (matched.length !== 1 ? 'er' : '') + '</span>'
        + metaSuffix;
      _dwfEl('dwf-res-tag').textContent = catLabel ? 'Kategori: ' + catLabel : '';

      _dwfRender(matched);

      var res = _dwfEl('dwf-results');
      res.style.display = 'block';
      res.scrollIntoView({ behavior: 'smooth', block: 'start' });

    } catch (err) {
      console.error('[DWF]', err);
    } finally {
      _dwfEl('dwf-loading').style.display = 'none';
    }
  }
};

/* ── Init on DOM ready ──────────────────────────────────── */
(function() {
  function init() {
    var root = _dwfEl('dwf-root');
    if (!root) return;
    _DWF_GAP.min = parseInt(root.dataset.airGapMin) || 2;
    _DWF_GAP.max = parseInt(root.dataset.airGapMax) || 5;
    _dwfUpdatePreview(_DWF_STATE.w, _DWF_STATE.h);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init(); /* already parsed */
  }
})();